import { ConversationMetadata } from 'types/ai.types';
import { YearlyReviewData } from 'types/global.types';
import { useSetAiMetadata } from '.';

export const mapYearlyReviewMetadata = (
  wrapped: Partial<YearlyReviewData>,
): ConversationMetadata => ({
  documentType: 'wrapped_2024',
  data: { ...wrapped },
});

export const useYearlyReviewAiMetadata = (
  wrapped?: Partial<YearlyReviewData>,
): void => useSetAiMetadata(wrapped, 'wrapped_2024', mapYearlyReviewMetadata);
